import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=1633cff4&scoped=true&"
var script = {}
import style0 from "./Section2.vue?vue&type=style&index=0&id=1633cff4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633cff4",
  null
  
)

export default component.exports